import { Store } from "@ngrx/store";
import { Injectable } from "@angular/core";
import { AppState } from "../models/app.state";

@Injectable()
export class LocationService {
    public userCoords: Coordinates;
    public maxDistance: number;
    
}


// WEBPACK FOOTER //
// C:/Users/majli/reposales365/sale365/src/app/shared/geolocation.service.ts